var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"sign_up",class:[_vm.theme, _vm.layout_choice]},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"inner"},[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"content"},[(_vm.title)?_c('h2',{class:{ 'has-text': _vm.text },domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),(_vm.text)?_c('div',{staticClass:"sign_up__inner",domProps:{"innerHTML":_vm._s(_vm.text)}}):_vm._e()])],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/SignUp.vue